import React from "react";
import styled from "styled-components";

export default function SpaceText() {
  return <Space>------</Space>;
}
const Space = styled.span`
  opacity: 0;
`;
